import React from "react";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Categories from "./pages/Categories";

const App = () => {
  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();
    const disableDrag = (e) => e.preventDefault();

    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("dragstart", disableDrag);

    // Nettoyage à la destruction du composant
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("dragstart", disableDrag);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/c/1" element={<Home />} />
        <Route path="/c/:catId/:subCatId" element={<Categories />} />
        <Route path="/c/:catId" element={<Categories />} />
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
